export default __webpack_public_path__ + "images/1483d06419fec8cf43a1938ce86b1a08-other_party_small.webp";